<script lang="ts">
	import ArticleCard from '@app/components/cards/ArticleCard.svelte';
	import HeroBlog from '@app/components/cms/blog/HeroBlog.svelte';
	import { viewport } from '$lib/stores';
	import Pagination from '$lib/components/Pagination.svelte';
	import { beforeUpdate } from 'svelte';
	import type { PaginationInfo } from '$lib/types/Pagination';
	import PageHead from '@app/components/PageHead.svelte';
	import { getArticlesByCategories } from '@app/services/blog.js';
	import { logError } from '@app/utils/log';

	let numberArticleByPage: number = 8;
	export let data;

	$: ({ category, articles, endCategoryContent, fetchLoader } = data);

	export let paginationInfo: PaginationInfo = {
		size: 0,
		totalElements: 0,
		totalPages: 0,
		number: 0
	};

	$: {
		numberArticleByPage = $viewport.isMobile ? 8 : 24;

		if (articles && articles.perPage != numberArticleByPage && paginationInfo) {
			updateArticles()
				.then((data) => (articles = data))
				.catch(reason => logError("unexpected error getting articles", reason));
			paginationInfo = {
				size: articles.total,
				totalElements: articles.total,
				totalPages: Math.ceil(articles.total / numberArticleByPage),
				number: paginationInfo.number
			};
		}
	}

	beforeUpdate(() => {
		if (!paginationInfo.totalPages) {
			paginationInfo = {
				size: articles?.total,
				totalElements: articles?.total,
				totalPages: Math.ceil(articles?.total / numberArticleByPage)
			};
		}
	});

	const onPageChange = async () => {
		articles = await updateArticles();
	};

	const updateArticles = async () => {
		return await getArticlesByCategories(
			[category.uuid],
			numberArticleByPage,
			paginationInfo.number + 1,
			fetchLoader
		);
	};
</script>

<section>
	{#if category}
		<PageHead
			title={category.content.metaTitle}
			desc={category.content.metaDescription}
			shareImage={category?.content?.image.filename}
		/>
		<HeroBlog
			classNames={'max-h-[380px] md:max-h-[650px]'}
			title={`<h1><span>${category.name}</span></h1>`}
			image={category.content.image}
			article
		/>
	{/if}

	{#if articles}
		<div class="container">
			<div class=" flex flex-wrap lg:grid lg:grid-cols-4 gap-4 mt-6">
				{#each articles?.data?.stories as article}
					<ArticleCard classNames={'!mx-auto  max-w-[300px]'} {article} />
				{/each}
			</div>
			<Pagination bind:data={paginationInfo} on:load={onPageChange} />
		</div>
	{/if}
</section>

{#if endCategoryContent?.length}
	{#each endCategoryContent as comp}
		<section class="mb-5">
			<svelte:component this={comp.svelteComp} blok={comp.CMSComp} />
		</section>
	{/each}
{/if}
